import { Account } from '../../../types';
import { useEffect, useState } from 'react';
import { getAccounts, getSelectedAccountsSubject } from '../../../store/User';
import { BasicAccountMultiSelect } from '../BasicAccountMultiSelect';

export interface AccountMultiSelectProps {
  accounts: Account[];
  handleAccountSelect: (acct: Account[] | null) => void;
}

export const AccountMultiSelect = ({ accounts, handleAccountSelect }: AccountMultiSelectProps) => {
  const [displayAccounts, setDisplayAccounts] = useState<Account[]>([]);
  const [selectedAccounts, setSelectedAccounts] = useState<Account[] | null>([]);

  const handleChange = (e: React.SyntheticEvent<Element, Event>, value: Account[] | null) => {
    handleAccountSelect(value);
  };

  const handleSelectAll = () => {
    handleAccountSelect(getAccounts() || []);
  };

  const handleSelectNone = () => {
    handleAccountSelect([]);
  };

  useEffect(() => {
    const selectedAcctSub = getSelectedAccountsSubject().subscribe((acct) => {
      setSelectedAccounts(acct);
      const selectedIds = acct?.map((acc) => acc.id);

      const sortedAccounts = accounts.sort((a, b) => {
        const aSelected = selectedIds?.includes(a.id) ? 0 : 1;
        const bSelected = selectedIds?.includes(b.id) ? 0 : 1;

        if (aSelected !== bSelected) {
          return aSelected - bSelected;
        }

        return (a.name || '').localeCompare(b.name || '');
      });

      setDisplayAccounts(sortedAccounts);
    });

    return () => {
      if (selectedAcctSub) selectedAcctSub.unsubscribe();
    };
  }, []);

  return (
    <BasicAccountMultiSelect
      displayAccounts={displayAccounts}
      selectedAccounts={selectedAccounts}
      handleChange={handleChange}
      handleSelectAll={handleSelectAll}
      handleSelectNone={handleSelectNone}
    />
  );
};
